import * as React from 'react';
import './UnauthorizedAccess.css';

export type ErrorType = 'AUTH_FAILED' | 'FORBIDDEN' | 'EXPIRED' | 'NETWORK';

export interface UnauthorizedAccessProps {
  errorMessage: string;
  errorType: ErrorType;
  onRetry: () => void;
}

const UnauthorizedAccess: React.FC<UnauthorizedAccessProps> = ({
  errorMessage,
  errorType,
  onRetry,
}) => {
  const getIcon = (): string => {
    switch (errorType) {
      case 'FORBIDDEN':
        return 'block';
      case 'EXPIRED':
        return 'lock';
      case 'AUTH_FAILED':
      case 'NETWORK':
      default:
        return 'error';
    }
  };

  const getTitle = (): string => {
    switch (errorType) {
      case 'FORBIDDEN':
        return "Don't Have Access to this Add-in";
      case 'EXPIRED':
        return 'Session Expired';
      case 'NETWORK':
        return 'Connection Error';
      case 'AUTH_FAILED':
      default:
        return 'Authentication Failed';
    }
  };

  return (
    <div className="unauthorized-container">
      <main className="unauthorized-content">
        <span className="material-icons-round unauthorized-icon">
          {getIcon()}
        </span>
        <h1 className="unauthorized-title">{getTitle()}</h1>
        {/* <p className="unauthorized-message">{errorMessage}</p> */}
        <button className="unauthorized-retry-btn" onClick={onRetry}>
          Retry Authentication
        </button>
      </main>
    </div>
  );
};

export default UnauthorizedAccess;
